export const GET_TECHNICAL_DATA = 'technical-data/GET_TYPES_TECHNICAL_DATA';
export const SET_TECHNICAL_DATA = 'technical-data/SET_TECHNICAL_DATA';

export default {
	GET_TECHNICAL_DATA,
	SET_TECHNICAL_DATA,
};
